<div class="Content_outer">
  <div class="content_view">
     <div class="row">
        <div class="col-md-12">
           <div class="newform_outer">
              <div class="filter_div">
                 <div class="top">
                    <h4>Energymeter</h4>
                 </div>
              </div>
              <div class="both_side add_asset">
                 <div class="left_side">
                    <div class="inner">
                      <div class="container ng-star-inserted" style="padding-top: 46px;">
                        <div class="row">
                           <div class="col col-md-12">
                              <h4>Energymeter Templates</h4>
                              <span class="custom_select_outer"></span>
                              <div class="row">
                                <div class="col-sm col-md-12">
                                   <div class="EditView MOTOR gearCoupling motorView">
                                      <div class="MOTOR left">
                                         <span class="right"></span>
                                         <span class="center">
                                            <!-- <button data-mac="" disabled="" class="ng-star-inserted" style="background-color: rgb(255, 179, 179);">1</button> -->
                                         </span>
                                         <span class="left"></span>
                                         <img alt="devicetTemplate" src="./assets/images/energy-meter.png" class="ng-star-inserted" style="width: 255px; margin-left: 28px;">
                                      </div>
                                      <div class="motor right"></div>
                                   </div>
                                </div>
                             </div>
                           </div>
                        </div>
                     </div>
                    </div>
                 </div>
                 <div class="right_side">
                    <div class="row"></div>
                    <div class="ng-star-inserted">
                     <form [formGroup]="energyMeterForm" class="ng-untouched ng-pristine ng-invalid ng-valid">

                          <h4>{{title}} </h4>

                          <div class="row">                           
                             <div class="col-md-6 col">
                                <label for="subsystem">Subsystem Name *<span class="material-icons info" ngbPopover="Asset Name, given by the Client, e.g. Mixer Motor 1" triggers="mouseenter:mouseleave">info</span></label>
                                <input type="hidden" name="client_id" id="client_id" [value]="userID">
                                <input id="subsystem" formControlName="subsystem" class="mat-autocomplete-trigger form-control" [value]="">
                                <!-- <div *ngIf="subsystem.invalid && (subsystem.dirty || subsystem.touched)" class="error">
                                  <div *ngIf="subsystem.errors?.required">Subsystem is required.</div>
                                </div>  -->
                             </div>

                             <div class="col-md-6 col"></div>
                          </div>

                          <div class="row">
                            <div class="col col-md-6">
                              <label for="site">Site <span class="material-icons info" ngbPopover="Site Name" triggers="mouseenter:mouseleave">info</span></label>
                              <span class="custom_select_outer ng-star-inserted">
                                <select id="site" formControlName="site" class="custom_select form-control pb-6"  (change)="getEnergymeterAllSiteById($event.target.value)">
                                  <option value="">Select Site</option>
                                  <option *ngFor="let site of sites" [value]="site.id">{{site.name}}</option>
                                </select>
                                <div *ngIf="site.invalid && (site.dirty || site.touched)" class="error">
                                  <div *ngIf="site.errors?.required">Site is required.</div>
                                </div>
                              </span>                              
                           </div>
                             <div class="col col-md-6">
                              <label for="application">Application *<span class="material-icons info" ngbPopover="Name of the Application, given by the Client, e.g. Scrubber Application" triggers="mouseenter:mouseleave">info</span></label>
                              <span class="custom_select_outer ng-star-inserted">                                 
                                 <select id="application" formControlName="application" class="custom_select form-control  pb-6" (change)="onApplicationSelect($event.target.value)">
                                    <option value="">Select Application</option>
                                    <option *ngFor="let app of applications" [value]="app.id">{{app.name}}</option>
                                  </select>
                                  <div *ngIf="application.invalid && (application.dirty || application.touched)" class="error">
                                    <div *ngIf="application.errors?.required">Application is required.</div>
                                  </div>
                              </span>                              
                             </div>
                          </div>

                          <hr class="horizontal_line">

                          <div class="row">
                              <div class="col-md-6 col">
                                 <label for="serialNumber">Mac Address *<span class="material-icons info" ngbPopover="Serial Number" triggers="mouseenter:mouseleave">info</span></label>
                                 <select id="serialNumber" formControlName="serialNumber" class="custom_select form-control  pb-6" (change)="onSelectSerailNumber($event.target.value)">
                                    <option value="">Select Mac Address</option>
                                    <option *ngFor="let device of availableDeviceData" [value]="device.mac_address">{{device.mac_address}}</option>
                                  </select>        
                                  <div *ngIf="serialNumber.invalid && (serialNumber.dirty || serialNumber.touched)" class="error">
                                    <div *ngIf="serialNumber.errors?.required">Serial Number is required.</div>
                                  </div>
                              </div>

                              <div class="col-md-6 col">
                                    <label for="name">Device Serial *<span class="material-icons info" ngbPopover="Device identifiers" triggers="mouseenter:mouseleave">info</span></label>
                                    <input id="name" formControlName="name" class="form-control" readonly [value]="deviceName">
                                    <div *ngIf="name.invalid && (name.dirty || name.touched)" class="error">
                                       <div *ngIf="name.errors?.required">Name is required.</div>
                                    </div>                               
                              </div>
                          </div>

                          <div class="row">
                              <div class="col col-md-6">
                                 <label for="address">Serial Number *<span class="material-icons info" ngbPopover="Energymeter device_sno." triggers="mouseenter:mouseleave">info</span></label>
                                 <span class="custom_select_outer">
                                    <input type="text" id="gn_serial_number" formControlName="gn_serial_number"  class="mat-autocomplete-trigger form-control" [value]="newgenericSerialNo" readonly >
                                    <!-- <div *ngIf="address.invalid && (address.dirty || address.touched)" class="error">
                                    <div *ngIf="address.errors?.required">Address is required.</div>
                                    </div> -->
                                 </span>
                              </div>

                              <div class="col col-md-6">                                
                                 <label for="address">Address *<span class="material-icons info" ngbPopover="Energymeter Address." triggers="mouseenter:mouseleave">info</span></label>
                                 <span class="custom_select_outer">
                                    <input type="text" id="address" formControlName="address" readonly class="mat-autocomplete-trigger form-control">
                                    <div *ngIf="address.invalid && (address.dirty || address.touched)" class="error">
                                    <div *ngIf="address.errors?.required">Address is required.</div>
                                    </div>
                                 </span>
                              </div>
                          </div>
                          
                          <div class="row">
                              <div class="col col-md-6">
                              <label for="country">Country *<span class="material-icons info" ngbPopover="Energymeter Country" triggers="mouseenter:mouseleave">info</span></label>
                              <span class="custom_select_outer ng-star-inserted">
                                 <select id="country" formControlName="country"  disabled  [(ngModel)]="selectedCountry" class="custom_select form-control pb-6"  (change)="onCountryChange($event.target.value)">
                                    <option value="">Select Country</option>
                                    <option *ngFor="let country of countries" [value]="country.id">{{country.name}}</option>
                                 </select>
                                 <div *ngIf="country.invalid && (country.dirty || country.touched)" class="error">
                                    <div *ngIf="country.errors?.required">Country is required.</div>
                                 </div>
                              </span>
                              </div>

                              <div class="col col-md-6">
                                 <label for="state">State *<span class="material-icons info" ngbPopover="Energymeter State" triggers="mouseenter:mouseleave">info</span></label>
                                 <span class="custom_select_outer">
                                       <select id="state" formControlName="state" disabled  [(ngModel)]="selectedState" class="custom_select form-control pb-6" >
                                          <option value="">Select State</option>
                                          <option *ngFor="let state of states" [value]="state.id">{{state.name}}</option>
                                       </select>
                                       <div *ngIf="state.invalid && (state.dirty || state.touched)" class="error">
                                          <div *ngIf="state.errors?.required">State is required.</div>
                                       </div>
                                 </span>
                              </div>
                          </div>

                          <div class="row">
                             <div class="col col-md-6">
                              <label for="latitude">Latitude *<span class="material-icons info" ngbPopover="Energymeter Latitude" triggers="mouseenter:mouseleave">info</span></label>
                              <input id="latitude" formControlName="latitude"  readonly  class="form-control ng-untouched ng-pristine ng-invalid">
                              <div *ngIf="latitude.invalid && (latitude.dirty || latitude.touched)" class="error">
                                <div *ngIf="latitude.errors?.required">Latitude is required.</div>
                                <div *ngIf="latitude.errors?.pattern">Latitude must be a valid number.</div>
                              </div>
                             </div>

                             <div class="col col-md-6">
                                 <label for="longitude">Longitude *<span class="material-icons info" ngbPopover="Energymeter Longitude" triggers="mouseenter:mouseleave">info</span></label>
                                 <input id="longitude" formControlName="longitude"  readonly  class="form-control ng-untouched ng-pristine ng-invalid">
                                 <div *ngIf="longitude.invalid && (longitude.dirty || longitude.touched)" class="error">
                                 <div *ngIf="longitude.errors?.required">Longitude is required.</div>
                                 <div *ngIf="longitude.errors?.pattern">Longitude must be a valid number.</div>
                                 </div>
                             </div>
                          </div>

                          <hr class="horizontal_line">
                          <h4>Gateway Details </h4>

                          <div class="row">
                            <div class="col col-md-6">
                              <label for="gw_devicetype_id">Devices <span class="material-icons info" ngbPopover="Gateway Name" triggers="mouseenter:mouseleave">info</span></label>
                              <span class="custom_select_outer ng-star-inserted">
                                <select id="gw_devicetype_id" formControlName="gw_devicetype_id" class="custom_select form-control pb-6" (change)="getGatewayById($event.target.value)">
                                  <option value="">Select Gateway</option>
                                  <option *ngFor="let gateway of gatewayDeviceData" [value]="gateway.id">{{gateway.name}}</option>
                                </select>
                                <div *ngIf="gw_devicetype_id.invalid && (gw_devicetype_id.dirty || gw_devicetype_id.touched)" class="error">
                                  <div *ngIf="gw_devicetype_id.errors?.required">Site is required.</div>
                                </div>
                              </span>                       
                           </div>

                           <div class="col-md-6 col">
                            <label for="gw_device_id">Mac Address *<span class="material-icons info" ngbPopover="Mac Addresses" triggers="mouseenter:mouseleave">info</span></label>
                            <select  id="gw_device_id" formControlName="gw_device_id" class="custom_select form-control pb-6" (change)="onSelectDevice($event.target.value)">
                               <option value="">Select Mac Addresse</option>
                               <option *ngFor="let macaddress of gatewayMacAddressDeviceData" [value]="macaddress.id">{{macaddress.mac_address}}</option>
                             </select>        
                             <div *ngIf="gw_device_id.invalid && (gw_device_id.dirty || gw_device_id.touched)" class="error">
                               <div *ngIf="gw_device_id.errors?.required">Serial Number is required.</div>
                             </div>
                         </div>
                          </div>

                          <hr class="horizontal_line">
                          
                          <h4 *ngIf="title=='Add Energymeter'">Device Configuration</h4>

                           <div *ngIf="title=='Add Energymeter'" class="row">
                            <div class="col col-md-6">
                              <label for="energymeter_data_push_rate">High Res Data Push Rate (mins) * <span class="material-icons info" ngbPopover="Data push rate per min" triggers="mouseenter:mouseleave">info</span></label>
                              <span class="custom_select_outer ng-star-inserted">
                                <select id="energymeter_data_push_rate" formControlName="energymeter_data_push_rate" class="custom_select form-control pb-6" (change)="getDataPushRate($event.target.value)">
                                  <option value="">Select Gateway</option>
                                  <option *ngFor="let pushRate of emDataPushRate" [value]="pushRate.key">{{pushRate.value}}</option>
                                </select>
                                <div *ngIf="energymeter_data_push_rate.invalid && (energymeter_data_push_rate.dirty || energymeter_data_push_rate.touched)" class="error">
                                  <div *ngIf="energymeter_data_push_rate.errors?.required">EM data push rate is required.</div>
                                </div>
                              </span>                       
                            </div>
                          </div> 

                          <div class="form_actions text-right">
                               <span *ngIf="title=='Add Energymeter'" class="ng-star-inserted">
                                
                                  <button *ngIf="!showUpdateBtn" mat-raised-button (click)="onSubmit()" [disabled]="!energyMeterForm.valid" type="submit" [disabled]="!energyMeterForm.valid" class="mat-focus-indicator primary_btn mat-raised-button mat-button-base ng-star-inserted">
                                    <span class="mat-button-wrapper">{{ showButtontxt }}</span>
                                    <span class="mat-ripple mat-button-ripple"></span>
                                    <span class="mat-button-focus-overlay"></span>
                                  </button>

                                  <!-- Update Button (when showUpdateBtn is true) -->
                                  <button *ngIf="showUpdateBtn" mat-raised-button (click)="onUpdate()" [disabled]="!energyMeterForm.valid || !energyMeterForm.dirty"  class="mat-focus-indicator primary_btn mat-raised-button mat-button-base ng-star-inserted">
                                    <span class="mat-button-wrapper">{{ showButtontxt }}</span>
                                    <span class="mat-ripple mat-button-ripple"></span>
                                    <span class="mat-button-focus-overlay"></span>
                                  </button>
                              </span> 
                           <button mat-raised-button="" type="button" class="mat-focus-indicator default_btn mat-raised-button mat-button-base"  (click)="goBack()">
                              <span class="mat-button-wrapper">
                                 <span _ngcontent-wem-c247="" class="mat-button-wrapper"> Back </span>
                                 <span _ngcontent-wem-c247="" matripple="" class="mat-ripple mat-button-ripple"></span>
                                 <span _ngcontent-wem-c247="" class="mat-button-focus-overlay"></span></span>
                              <span matripple="" class="mat-ripple mat-button-ripple"></span><span class="mat-button-focus-overlay"></span>
                           </button>
                           <!-- <button type="submit" class="full-width-button">Submit</button> -->
                        </div>
                       </form>
                    </div>
                 </div>
              </div>
           </div>
        </div>
     </div>
  </div>
</div>
